<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @showDetail="showDetail"
      @checkboxChange="(e) => (checkedRow = e)"
    >
      <page-header
        ref="header"
        slot="header"
        :checked-count="checkedCount"
        @query="getData"
        @reset="resetPage"
        @putShelves="putShelvesVisible = true"
        @followSale="followSaleVisible = true"
        @crossSiteSales="crossSiteSalesVisible = true"
        @unsaleable="unsaleable()"
        @availableSale="availableSale()"
        @disableDisplay="disableDisplay()"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>

    <PutShelves :visible.sync="putShelvesVisible" @reload="reload" />
    <Detail :visible.sync="detailVisible" :platformCode="platformCode" :evgSkuPlatformCode="evgSkuPlatformCode" @reload="reload" />
  </div>
</template>
<script>
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import PageHeader from './header'
import PageMain from './main.vue'
import PutShelves from '../put-shelves'
import Detail from '../detail'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageMain, PageHeader, PutShelves, Detail },
  data() {
    return {
      usePage: true,
      checkedRow: [],
      putShelvesVisible: false,
      followSaleVisible: false,
      crossSiteSalesVisible: false,
      detailVisible: false,
      platformCode: '',
      evgSkuPlatformCode: ''
    }
  },
  computed: {
    checkedCount() {
      return !this.checkedRow ? 0 : this.checkedRow.length
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomEvgSkuPlatformListingListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
          this.checkedRow = []
        })
        .catch(() => {
          this.loading = false
        })
    },
    unsaleable() {
      if (!this.checkedCount) {
        this.$message({
          message:
            this.$l('tips_please_unsaleable') || '请选择需要修改为不可售的SKU',
          type: 'warning',
        })
        return
      }
      const listCode = this.checkedRow.map((item) => item.evgSkuPlatformCode)
      this.$confirm(
        this.$l('tips_confirm_unsaleable') ||
          '是否要将选择中的记录修改为不可售',
        this.$l('tips_confirm_unsaleable_title') || '确认信息',
        {
          confirmButtonText:
            this.$l('btn_unsaleable_confirm') || '确定',
          cancelButtonText: this.$l('btn_unsaleable_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        this.loadingOpen()
        const res = await this.$api
          .ecomEvgSkuPlatformUnsaleableApi({ listCode })
          .catch(() => null)
        this.loadingClose()
        const { status } = res || {}
        if (status !== 200) {
          this.$message.error(this.$l('tips_unsaleable_update_no') || '修改失败！')
          return
        }
        this.$message({
          showClose: true,
          message: this.$l('tips_unsaleable_update_ok') || '修改成功！',
          type: 'success',
        })
        this.reload()
      })
    },
    availableSale() {
      if (!this.checkedCount) {
        this.$message({
          message:
            this.$l('tips_please_availableSale') || '请选择需要修改为可售的SKU',
          type: 'warning',
        })
        return
      }
      const listCode = this.checkedRow.map((item) => item.evgSkuPlatformCode)
      this.$confirm(
        this.$l('tips_confirm_availableSale') ||
          '是否要将选择中的记录修改为可售',
        this.$l('tip_confirm_available_sale_title') || '确认信息',
        {
          confirmButtonText:
            this.$l('btn_available_sale_confirm') || '确定',
          cancelButtonText: this.$l('btn_available_sale_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        this.loadingOpen()
        const res = await this.$api
          .ecomEvgSkuPlatformAvailableSaleApi({ listCode })
          .catch(() => null)
        this.loadingClose()
        const { status } = res || {}
        if (status !== 200) {
          this.$message.error(this.$l('tips_available_sale_update_no') || '修改失败！')
          return
        }
        this.$message({
          showClose: true,
          message: this.$l('tips_available_sale_update_ok') || '修改成功！',
          type: 'success',
        })
        this.reload()
      })
    },
    showDetail({platformCode, evgSkuPlatformCode}) {
      this.detailVisible = true
      this.platformCode = platformCode
      this.evgSkuPlatformCode = evgSkuPlatformCode
    },
  },
}
</script>
